module.exports = __webpack_public_path__ + "static/media/loader_nw.267b1d2a.gif";